import secureRequest from "@toothfairy/shared-api/secureAPI";
import client from "@toothfairy/shared-api/src/Common/client";
import envConfig from "../../../envConfig";
import { key_id } from "../../../App";
import Common from "../Common";

const processAudio = async ({ token, data }) => {
  const headers = { "x-api-key": Common.decrypt(key_id()) };
  let url = `${envConfig.REACT_APP_REST_ENDPOINT}/media/audio`;
  const body = data;

  return secureRequest(client, "POST", url, null, body, false, headers);
};

const generateAudio = async ({ token, data }) => {
  const headers = { "x-api-key": Common.decrypt(key_id()) };
  let url = `${envConfig.REACT_APP_REST_ENDPOINT}/media/audio_generation`;
  const body = data;

  return secureRequest(client, "POST", url, null, body, false, headers);
};

export default {
  processAudio,
  generateAudio,
};
